import React from 'react'
import { useS3DirectUpload } from '#hooks/useS3DirectUpload'

export const withS3DirectUpload = Component => {
  return function WrappedComponent(props) {
    const [directUploadParams, setDirectUploadParams, directUploadRequest] = useS3DirectUpload('')

    return (
      <Component
        {...props}
        setDirectUploadParams={setDirectUploadParams}
        directUploadParams={directUploadParams}
        directUploadRequest={directUploadRequest}
      />
    )
  }
}
